import React from 'react';
import { withIdleTimer } from 'react-idle-timer';

// eslint-disable-next-line react/jsx-no-useless-fragment
const IdleTimerComponent = () => (<></>);

export default withIdleTimer(IdleTimerComponent);
